<div class="relative flex w-fit max-w-full min-w-0">
  <button
    iButton
    variant="ghost"
    size="sm"
    class="block max-w-full px-2 py-1 text-sm font-medium text-gray-800 hover:bg-gray-50"
    (click)="toggleEditMode()"
    [ngClass]="editMode() ? 'invisible' : 'visible'"
    [iTooltip]="disable() ? undefined : tooltipText()"
    iTooltipPlacement="right-center"
  >
    {{ writableLabel() }}
  </button>
  <input
    #inputEl
    class="focus:ring-main-300 absolute top-0 left-0 w-full max-w-full rounded-lg px-2 py-1 text-sm font-medium tracking-tight text-gray-800 outline-hidden duration-150 ring-inset focus:ring-1"
    autofocus
    [value]="writableLabel()"
    [ngClass]="editMode() ? 'inline-block' : 'hidden'"
    (blur)="onBlur()"
    (change)="updateLabel($event)"
    (keydown)="onKeydownEnter($event)"
  />
</div>
